import { EMAIL_REGEX, IMAGE_BASE_URL } from "@c4c-web/libs-hooks/constants";
import { isServer } from "./env.utils";

export const getFallbackImageUrl = (): string => {
  return getStaticImageUrl("fallback-image.png");
};

export function getSanitizedValue(input: string): string {
  return input.replace(/[<>]/g, "");
}

export const getStaticImageUrl = (
  url: string,
  isFlag?: boolean,
  isSvg?: boolean,
): string => {
  if (isSvg) {
    return `${IMAGE_BASE_URL}/assets/svgs/${url}`;
  } else if (isFlag) {
    return `${IMAGE_BASE_URL}/assets/flags/${url}`;
  }
  return `${IMAGE_BASE_URL}/assets/images/${url}`;
};

export const isValidEmail = (value: string) => {
  return EMAIL_REGEX.test(value);
};

export const decodeAndSanitizeHtml = (str: string): string => {
  const decoded = str
    .replace(/&amp;/g, "&")
    .replace(/&gt;/g, ">")
    .replace(/&lt;/g, "<")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, " ");

  let result = "";
  let inTag = false;
  for (const char of decoded) {
    if (char === "<") {
      inTag = true;
    } else if (char === ">" && inTag) {
      inTag = false;
    } else if (!inTag) {
      result += char;
    }
  }
  return result;
};

export const isValidNumber = (value: string | number): boolean => {
  return !isNaN(Number(value));
};

export const sanitizeMarkupOnClient = (str: string): string => {
  // Client side sanitization and pull the text content from HTML string
  if (isServer()) {
    return str;
  }
  const parser = new DOMParser();
  const markup = parser.parseFromString(str, "text/html");
  return markup.body.textContent ?? "";
};

export const isNonEmptyArray = (array: unknown): boolean => {
  return Array.isArray(array) && array.length > 0;
};

// Utility to omit selected keys from an object (returns a new object, no delete)
export const omitKeys = <T extends object, K extends keyof T>(
  obj: T,
  keys: K[],
): Omit<T, K> => {
  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => !keys.includes(key as K)),
  ) as Omit<T, K>;
};
